module.exports = __webpack_public_path__ + "static/fonts/Fact-Black.994e5d1.woff2";